<template>
  <header class="nav-header">
    <nav class="header-container">
      <div class="navigation">
        <div class="logo">
          <router-link
            :to="{ name: 'home' }"
            class="navbar-item logo-block"
            exact
          >
            <img :src="portalLogoBase64" :alt="portalName" />
            <span class="navbar-brand-name"> {{ portalName }} </span>
          </router-link>
          <div></div>
        </div>
        <div class="navigation-tabs">
          <router-link
            :to="{
              name: 'map',
              params: { projectSchema: currentProject.schema },
            }"
            class="navigation-tab"
          >
            Карта
          </router-link>
          <router-link
            :to="{
              name: 'gisogdSections',
              params: { projectSchema: currentProject.schema },
            }"
            class="navigation-tab"
          >
            Документы
          </router-link>
        </div>
      </div>
      <button
        :class="['burger', { active: isBurgerActive }]"
        @click="toggleBurger"
        aria-label="Открыть меню"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="search-block"><slot></slot></div>

      <div class="navigation-links">
        <div class="user-info navbar-menu">
          <div class="navbar-item has-dropdown is-hoverable schema-dropdown">
            <a class="navbar-link">
              {{ currentProjectName }}
            </a>
            <div class="navbar-dropdown is-right">
              <custom-scroll class="projects-dropdown">
                <router-link
                  v-for="project in projects"
                  :key="project.schema"
                  :to="{
                    name: 'map',
                    params: { projectSchema: project.schema },
                  }"
                  class="navbar-item"
                >
                  {{ project.name }}
                </router-link>
              </custom-scroll>
            </div>
          </div>
          <a :href="imoksUrl" class="router-link" v-if="imoksToGisogdEnabled === 'true'">
            <navigation-button>Передача ИМ ОКС</navigation-button>
          </a>
          <a
            href="/doc/usages/GISOGD.portal/help.index.html"
            class="router-link"
            :tabindex="-1"
          >
            <icon-button tooltip="Справка" :iconSrc="userIcon"
          /></a>
        </div>
      </div>

      <div
        :class="['burger-dropdown', 'navbar-end', { hidden: !isBurgerActive }]"
      >
        <div class="search-block--mobile"><slot></slot></div>

        <div class="burger-dropdown-section">
          <router-link
            :to="{
              name: 'map',
              params: { projectSchema: currentProject.schema },
            }"
          >
            <navigation-button>Карта</navigation-button>
          </router-link>
          <router-link
            :to="{
              name: 'gisogdSections',
              params: { projectSchema: currentProject.schema },
            }"
          >
            <navigation-button>Документы</navigation-button>
          </router-link>
          <a :href="imoksUrl" class="router-link" v-if="imoksToGisogdEnabled === 'true'">
            <navigation-button>Передача ИМ ОКС</navigation-button>
          </a>
        </div>
        <a
          class="router-link"
          href="/doc/usages/GISOGD.portal/help.index.html"
          tabindex="-1"
        >
          <navigation-button :icon="userIcon">Справка</navigation-button>
        </a>
        <div class="navbar-item is-hoverable schema-dropdown">
          <a class="navbar-link">
            {{ currentProjectName }}
          </a>
          <div class="navbar-dropdown">
            <custom-scroll class="projects-dropdown">
              <router-link
                v-for="project in projects"
                :key="project.schema"
                :to="{
                  name: 'map',
                  params: { projectSchema: project.schema },
                }"
                class="navbar-item"
              >
                {{ project.name }}
              </router-link>
            </custom-scroll>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import IconButton from "@/components/IconButton";
import NavigationButton from "@/components/NavigationButton";
import { mapGetters, mapState } from "vuex";
import userIcon from "../assets/svg/user-help.svg";

export default {
  computed: {
    ...mapState(["projects", "currentProject"]),
    ...mapGetters(["portalName", "portalLogoBase64"]),
    currentProjectName() {
      return this.currentProject ? this.currentProject.name : "";
    },
  },
  methods: {
    toggleBurger() {
      this.isBurgerActive = !this.isBurgerActive; // переключение состояния
    },
  },
  data() {
    return {
      imoksToGisogdEnabled: process.env.VUE_APP_IMOKS2GISOGD_IS_ENABLED,
      imoksUrl: process.env.VUE_APP_IMOKS_CLIENT_URL,
      isBurgerActive: false,
      userIcon,
    };
  },
  components: {
    IconButton,
    NavigationButton,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/sass/main.scss";

.navbar-brand img {
  max-height: 48px;
  max-width: 100px;
}

.navbar-brand-name {
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  padding-left: 10px;
}

.button.is-link.is-active {
  background: $cyan;
}

.navbar-item.navbar-center {
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
}

.projects-dropdown {
  max-height: 200px;
}

@media screen and (max-width: 1024px) {
  .navbar-end {
    display: flex;
    flex-direction: column;
  }
}

.router-link {
  display: inline-flex;
  color: var(---color-neutral-20);
  text-decoration: none;
}

.title {
  font-weight: 400;
}

.navigation {
  display: flex;
  align-items: center;
  gap: 40px;
}
.logo-block {
  height: 64px;
  display: flex;
  align-items: center;
}
.schema-dropdown {
  height: 64px;

  @media (max-width: 1024px) {
    height: auto;
    padding: 0;
  }
}

.nav-header {
  position: relative;
  z-index: 1000;
  background-color: #fff;
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #263141;
  box-shadow: 0px 3px 5px 0px #00000033;
  padding-right: 14px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 21px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-container {
  max-width: unset;
  min-height: 63px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  margin: 0;
}

.navigation-links {
  display: flex;
  gap: 10px;
}

.burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  padding: 0;

  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #0b9096;
    margin: 1.5px 0;
    transition: all 0.3s;
  }

  &.active {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translateY(-3px) rotate(-45deg);
    }
  }

  @media (max-width: 1024px) {
    display: flex;
  }
}

.navigation-tabs {
  display: flex;

  @media (max-width: 1024px) {
    display: none;
  }
}
.navigation-tab {
  font-size: 15px;
  line-height: 21px;
  padding: 21px 10px;
  padding-top: 22px;
  cursor: pointer;
  color: #000;
  transition: background-color 0.3s;

  &:hover {
    background-color: #eef1fa;
  }
  &.is-active {
    color: #0b9096;
    border-top: 3px solid #0b9096;
    padding-top: 20px;
  }
}

.burger-dropdown {
  position: absolute;
  top: 63px;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  z-index: 200;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &.hidden {
    transform: translateY(-10px);
    opacity: 0;
    pointer-events: none;
  }

  &-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    &:not(:last-child) {
      padding-bottom: 30px;
      border-bottom: 1px solid #dde4f0;
    }
  }
  @media (min-width: 1024px) {
    display: none;
  }
}
.navigation-links {
  display: flex;
  @media (max-width: 1024px) {
    display: none;
  }
}

.search-block {
  width: 600px;
  &--mobile {
    > .search-field {
      max-width: unset;
    }
  }
  @media (max-width: 1300px) {
    width: auto;
  }
  @media (max-width: 1024px) {
    > .search-field {
      max-width: unset;
    }
    display: none;
  }
}
</style>
